/** PM CRUD — contact management, message/thread operations, search. */

/**
 * Clamp a recipient display name for inline use in confirmation copy, appending
 * an ellipsis when truncated. The profile `name` field is free-form and can be a
 * single unbroken token up to 120 chars (User::NAME_MAX_LEN), so interpolating it
 * whole into a fixed-width modal overflows the dialog. Default cap is 30 code
 * points. Slicing on code points (via Array.from) keeps the cap emoji-aware and
 * never splits a surrogate pair into a stray replacement glyph before the ellipsis.
 */
window.pmTruncateName = function(name, maxLen) {
  var value = String(name == null ? '' : name).trim();
  var limit = (typeof maxLen === 'number' && maxLen > 0) ? maxLen : 30;
  var chars = Array.from(value);
  if (chars.length <= limit) {
    return value;
  }
  return chars.slice(0, limit).join('').replace(/\s+$/, '') + '…';
};

window.add_contact = function() {
  let btn = $("#add_contact"),
    err_txt = "Error when adding new contact. Try again.",
    nc = $("#new_contact"),
    username = $.trim(nc.val());

  if ($("#new_contact:hidden").length) {
    nc.show();
    nc.animate({ "width": "90px", "margin-left": "-4px" }, 100);
    $("#add_contact_link").hide();
    $("#new_contact_button").show();
    return;
  }

  if (username.length < 3 || nc.attr("title") === username) {
    // Avoid double enter press after alert
    nc.blur();
    alert(window.t('common.pm.username_min_length'));
    return false;
  }

  if (!username.length) {
    alert(window.t('common.pm.enter_username'));
    return false;
  }

  btn.prop("disabled", true);

  // Set ajax request marker
  window.pm_ajax_request_active = 1;

  $.ajax({
    type: "POST",
    url: "/app/messages/add-contact",
    data: {
      "username": username
    },
    dataType: "json"
  }).done(function(data, textStatus, jqXHR) {
    if (data.success) {
      // Redirect to new thread
      if (window.pm_view_mode === "paged") {
        window.location.href = window.location.protocol + "//" +
          window.location.hostname + window.location.pathname +
          "?thread_id=" + data.thread_id;
        return false;
      }
      $("#new_contact").val("");
      // Remove duplicate thread id if any
      $("#thread_" + data.thread_id).remove();
      // Add just rendered thread
      $("#threads_left").prepend(data.body);
      // Initialize thread action buttons on the new element
      if (window.initializeThreadActions) window.initializeThreadActions();
      // Make new thread active
      window.view_thread(data.thread_id, true);
    } else {
      if (data.error) {
        alert(data.error);
      } else {
        alert(err_txt);
      }
    }
  }).fail(function(data, textStatus, jqXHR) {
    alert(err_txt);
  }).always(function() {
    // Unset ajax request marker
    window.pm_ajax_request_active = 0;
    btn.prop("disabled", false);
  });

  return false;
};

window.get_active_thread_id = function() {
  const re = /thread_id=(\d+)/;
  const rr = re.exec(window.location.href);

  if (rr && typeof rr != "undefined" && typeof rr[1] != "undefined" && $.isNumeric(rr[1])) {
    return rr[1];
  }
  return false;
};

window.get_active_thread_uid = function() {
  let thread = $("#threads_left").find(".pm_thread.active");
  if (thread.length) {
    return thread.data("uid");
  }
  return false;
};

window.navigate_to_report = function(uid) {
  if (window.openReportModal) {
    window.openReportModal('user', uid, uid);
  } else {
    window.location = "/app/report?todo=user&uid=" + uid;
  }
};

window.delete_message = function(id) {
  // Close the dropdown menu after clicking
  window.closeMessageActionMenus();

  var doDelete = function() {
    var err_txt = window.t('common.pm.delete_message_error');
    var btn = $("#del_msg_btn_" + id),
      tid = window.get_active_thread_id();

    if (!$.isNumeric(tid)) {
      window.location.reload();
      return false;
    }

    var cogrot = $("<i class=\"fa fa-cog cog-rot\"/>");
    btn.hide();
    btn.after(cogrot);

    window.pm_ajax_request_active = 1;
    $.ajax({
      type: "POST",
      url: "/app/messages/delete-message",
      data: {
        "thread": tid,
        "message_id": id
      },
      dataType: "json"
    }).done(function(data, textStatus, jqXHR) {
      if (data.success) {
        $("#msg_" + id).remove();
        if (window.window.pm_view_mode === "chat") {
          var last = $("#threads_right").children().last();
          if (last.hasClass("pm_date_div")) {
            last.remove();
          }
        }
      } else {
        if (data.error) {
          alert(data.error);
        } else {
          alert(err_txt);
        }
      }
    }).fail(function(data, textStatus, jqXHR) {
      alert(err_txt);
    }).always(function() {
      window.pm_ajax_request_active = 0;
      cogrot.remove();
      btn.show();
    });
  };

  if (window.ConfirmModal) {
    window.ConfirmModal.show({
      title: window.t('common.pm.delete_message_title'),
      message: window.t('common.pm.delete_message_confirm'),
      confirmText: window.t('common.delete'),
      type: 'danger',
      onConfirm: doDelete
    });
  } else {
    if (confirm(window.t('common.pm.delete_message_title') + '\n\n' + window.t('common.pm.delete_message_confirm'))) {
      doDelete();
    }
  }

  return false;
};

/**
 * Remove a recalled (unsent) message bubble from the open conversation in
 * place. Idempotent: a no-op if the row is already gone, so the own-side (API
 * response) removal and the live socket path can both fire safely. IDs are
 * treated as strings.
 *
 * Sibling: the websocket recall path in pm/polling.js has its own
 * applyMessageRecallRemoval that removes the same bubble for the live socket case.
 *
 * @param {string} messageId
 */
window.applyRecallRemoval = function(messageId) {
  // Removing a row reflows the list under any open dropdown, which is positioned
  // against a viewport rect that no longer holds.
  window.closeMessageActionMenus();

  var id = String(messageId);
  $('#msg_' + id).remove();
};

window.unsend_message = function(id) {
  // Close the dropdown menu after clicking.
  window.closeMessageActionMenus();

  var msgId = String(id);
  var recipientName = $.trim($('#current_thread_username').text());
  if (!recipientName) {
    var activeRow = $('#threads_left').find('.pm_thread.active');
    recipientName = activeRow.attr('data-name') || '';
  }

  var doUnsend = function() {
    var tid = window.get_active_thread_id();
    if (!$.isNumeric(tid)) {
      window.location.reload();
      return false;
    }

    var err_txt = window.t ? window.t('legacy.pm.unsend_error') : 'Could not unsend the message. Try again.';

    if (!window.ApiClient) {
      alert(err_txt);
      return false;
    }

    window.pm_ajax_request_active = 1;
    window.ApiClient.request(
      '/message/' + msgId + '/unsend?thread_id=' + String(tid),
      { method: 'POST' }
    ).then(function(response) {
      if (response.ok) {
        window.applyRecallRemoval(msgId);
        // Refresh the thread-list snippet: the recall rolled it back to the
        // prior message server-side. Idempotent: requestPoll is debounced.
        if (window.requestPoll) {
          window.requestPoll();
        }
        return;
      }
      return response.json().then(function(data) {
        alert((data && data.message) ? data.message : err_txt);
      }).catch(function() {
        alert(err_txt);
      });
    }).catch(function() {
      alert(err_txt);
    }).then(function() {
      window.pm_ajax_request_active = 0;
    });
  };

  var displayName = window.pmTruncateName(recipientName);

  var body = window.t
    ? window.t('legacy.pm.unsend_confirm_body', { name: displayName })
    : (displayName + " won't be able to see this message anymore.");

  if (window.ConfirmModal) {
    window.ConfirmModal.show({
      title: window.t ? window.t('legacy.pm.unsend_confirm_title') : 'Unsend message?',
      message: body,
      confirmText: window.t ? window.t('legacy.pm.unsend_confirm_button') : 'Unsend',
      type: 'warning',
      onConfirm: doUnsend
    });
  } else {
    if (confirm((window.t ? window.t('legacy.pm.unsend_confirm_title') : 'Unsend message?') + '\n\n' + body)) {
      doUnsend();
    }
  }

  return false;
};

window.mark_all_as_read = function() {
  var doMarkRead = function() {
    $.ajax({
      type: "POST",
      url: "/app/messages/mark-all-read",
      dataType: "json"
    }).done(function(data, textStatus, jqXHR) {
      // Auth/CSRF/onboarding gate returns {redirect: url}. The global
      // ajaxComplete handler navigates there, so skip the local reload.
      if (data && typeof data.redirect === 'string' && data.redirect) {
        return;
      }
      window.location.href = window.location.protocol + "//" +
        window.location.hostname + window.location.pathname;
    }).always(function() {
      window.pm_ajax_request_active = 0;
    });
  };

  if (window.ConfirmModal) {
    window.ConfirmModal.show({
      title: window.t('common.pm.mark_all_read_confirm'),
      confirmText: window.t('common.confirm'),
      type: 'info',
      onConfirm: doMarkRead
    });
  } else {
    if (confirm(window.t('common.pm.mark_all_read_confirm'))) {
      doMarkRead();
    }
  }
  return false;
};

window.delete_thread = function(t, id, block_user) {
  var isBlock = block_user == 1;

  // Hide swipe actions either way — the menu/swipe affordance shouldn't linger.
  $('.thread-swipe-actions').removeClass('translate-x-0').addClass('translate-x-full');

  if (isBlock) {
    var threadEl = $('#thread_' + id);
    var contactUid = String(
      threadEl.attr('data-uid') ||
      (window.get_active_thread_uid && window.get_active_thread_uid()) ||
      ''
    );
    var contactUsername = threadEl.attr('data-name') || threadEl.find('.thread-username').text() || '';
    if (window.openBlockDeleteModal) {
      window.openBlockDeleteModal({
        threadId: id,
        contactUid: contactUid,
        contactUsername: contactUsername
      });
      return false;
    }
  }

  var title = window.t('common.pm.delete_conversation_confirm');
  var message = window.t('common.pm.delete_conversation_detail');

  var doDelete = function() {
    var err_txt = window.t('common.pm.delete_thread_error');

    window.pm_ajax_request_active = 1;
    $.ajax({
      type: "POST",
      url: "/app/messages/delete-thread",
      data: {
        "thread": id,
        "block_user": block_user
      },
      dataType: "json"
    }).done(function(data, textStatus, jqXHR) {
      if (data.success) {
        // Route through removeThreadRow so the in-flight-poll guard
        // (_recentlyRemoved) is set and the chat pane is closed only when the
        // deleted thread is the open one. A delta poll already on the wire could
        // otherwise re-insert the row we just deleted, and an unconditional pane
        // close would wipe an unrelated open conversation.
        if (typeof window.removeThreadRow === "function") {
          window.removeThreadRow(id);
        } else {
          $("#thread_" + id).remove();
          if (window.pm_view_mode === "chat") {
            $("#threads_main").removeClass("threads--open");
            if (typeof $.scrollTo === "function" && $(".cCont").length) {
              $.scrollTo($(".cCont"));
            }
            $("#threads_right").empty();
          }
        }
      } else {
        if (data.error) {
          alert(data.error);
        } else {
          alert(err_txt);
        }
      }
    }).fail(function(data, textStatus, jqXHR) {
      alert(err_txt);
    }).always(function() {
      window.pm_ajax_request_active = 0;
    });
  };

  if (window.ConfirmModal) {
    window.ConfirmModal.show({
      title: title,
      message: message,
      confirmText: window.t('common.delete'),
      type: 'danger',
      onConfirm: doDelete
    });
  } else {
    if (confirm(title + '\n\n' + message)) {
      doDelete();
    }
  }

  return false;
};

window.report_message = function(id) {
  window.closeMessageActionMenus();

  if (window.openReportModal) {
    const threadUid = window.get_active_thread_uid ? window.get_active_thread_uid() : '';
    window.openReportModal('message', id, threadUid);
  } else {
    const wl = window.location;
    wl.href = wl.protocol + "//" + wl.host + "/app/report?todo=msg&msg_id=" + id + "&thread_id=" + window.get_active_thread_id();
  }
};

window.focus_msg_box = function() {
  // Focus on msg textarea.
  // For some reason doesn't always work if we do it immediately, so add a timeout.
  window.setTimeout(function() {
    $("#message").focus();
  }, 200);
};

window.load_more_msg = function() {
  let thread_id = window.get_active_thread_id();
  if (!thread_id) return;
  window.load_more_msg_active = 1;
  window.reload_ads();
  let t = $("#threads_right");
  let container = t[0];

  // Return if no "load more" btn
  if ($("#load_older_messages").length === 0) {
    window.load_more_msg_active = 0;
    return;
  }

  // Find first date divider and message before any DOM changes
  let first_datediv = t.find(".pm_date_div:first");
  let first_msg = t.find(".pm_msg:first");
  let first_msg_id = first_msg.attr("id")?.replace("msg_", "");

  // Hide the load older button instead of removing (to avoid layout shift)
  $("#load_older_messages").css("visibility", "hidden");

  // Set ajax request marker
  window.pm_ajax_request_active = 1;
  $.ajax({
    type: "POST",
    url: "/app/messages/load",
    data: {
      "thread": thread_id,
      "last_msg_id": first_msg_id
    },
    dataType: "json"
  }).done(function(data, textStatus, jqXHR) {
    // Auth/CSRF/onboarding gate returns {redirect: url}. The global
    // ajaxComplete handler navigates there, so skip rendering an error state.
    if (data && typeof data.redirect === 'string' && data.redirect) {
      return;
    }
    if (data.body) {
      let scrollTopBefore = container.scrollTop;

      // Remove load older button and prepend new content into wrapper
      $("#load_older_messages").remove();
      var wrapper = t.find('#messages_wrapper');
      var prependTarget = wrapper.length ? wrapper : t;
      prependTarget.prepend(data.body);

      // With column-reverse, prepending at the top of the wrapper adds content
      // at the visual top (furthest from scroll anchor). The browser may shift
      // scrollTop — restore it to keep the same messages in view.
      container.scrollTop = scrollTopBefore;

      // New msgs can arrive
      window.messages_highlighted = 1;

      // Remove duplicate date dividers
      if (!t.find(".no_messages").length) {
        var date = first_datediv.data("date");
        if (t.find("div[data-date=" + date + "]").length > 1) {
          first_datediv.remove();
        }
      }
    } else {
      $("#load_older_messages").remove();
      var wrapperErr = t.find('#messages_wrapper');
      var errTarget = wrapperErr.length ? wrapperErr : t;
      if (data.error) {
        errTarget.prepend(window.err_div.html(data.error));
      } else {
        errTarget.prepend(window.err_div.html(window.err_txt));
      }
    }
  }).fail(function(data, textStatus, jqXHR) {
    $("#load_older_messages").remove();
    var wrapperErr = t.find('#messages_wrapper');
    var errTarget = wrapperErr.length ? wrapperErr : t;
    errTarget.prepend(window.err_div.html(window.err_txt));
  }).always(function() {
    // Unset ajax request marker
    window.pm_ajax_request_active = 0;
    window.load_more_msg_active = 0;
  });
  return false;
};

window.reload_ads = function() {
  return; // Don't reload ads here for now (globally applied)
};

window.find_contact = function() {
  const username = $.trim($("#username_filter").val());

  const base_url = window.location.protocol + "//" + window.location.hostname + window.location.pathname;

  if (username.length === 0) {
    window.location.href = base_url;
  } else {
    const filter_url = base_url + "?filter=username&filter_value=" + encodeURIComponent(username);
    window.location.href = filter_url;
  }

  return false;
};

let debounceTimer;
window.debounce_find_contact = function(input) {
  clearTimeout(debounceTimer);

  debounceTimer = setTimeout(function() {
    const prev = input.getAttribute("data-filter-value");

    // Only call find_contact if the value is different from the original filter value
    if ((input.value.length >= 3 || input.value.length === 0) && input.value !== prev) {
      window.find_contact();
      // Update the original value
      input.setAttribute("data-filter-value", input.value);
    }
  }, 500);
};

window.load_older_conversations = function() {
  // If all threads are already loaded, do nothing
  if (window._threadsFullyLoaded) {
    return false;
  }
  // If there's no sentinel element, there are no more conversations to load
  var sentinel = document.getElementById('load_more_conversations');
  if (!sentinel) {
    return false;
  }

  window.load_more_threads_active = 1;
  window.reload_ads();
  let c = $("#threads_left"),
    fl = $("#filters");

  // Set ajax request marker
  window.pm_ajax_request_active = 1;

  $.ajax({
    type: "POST",
    url: "/app/messages/more-threads",
    data: {
      "from": c.find(".pm_thread").length,
      "filter": fl.data("filter")
    },
    dataType: "json"
  }).done(function(data, textStatus, jqXHR) {
    // Remove old sentinel before appending to avoid duplicate IDs
    $(sentinel).remove();

    if (data.body && data.body.includes("pm_thread")) {
      // Dedupe on append: a concurrent inbox delta may have already moved a
      // thread to the top while this offset-based page was loading. Appending it
      // again would duplicate the row, so skip any thread already in the DOM.
      var tmp = document.createElement('div');
      tmp.innerHTML = data.body;
      var frag = document.createDocumentFragment();
      Array.prototype.slice.call(tmp.children).forEach(function(el) {
        if (el.classList && el.classList.contains('pm_thread') && el.id && document.getElementById(el.id)) {
          return;
        }
        frag.appendChild(el);
      });
      c[0].appendChild(frag);

      // Initialize Lucide icons on the newly appended threads
      if (window.LucideIcons) {
        window.LucideIcons.initialize(c[0]);
      }

      // Show correct action UI (desktop dropdown vs mobile swipe) on newly appended threads
      if (typeof window.initializeThreadActions === 'function') {
        window.initializeThreadActions();
      }

      // If no sentinel in the response, all threads are loaded
      if (!document.getElementById('load_more_conversations')) {
        window._threadsFullyLoaded = true;
      }
    } else {
      // No more threads to load
      window._threadsFullyLoaded = true;
    }

  }).fail(function(data, textStatus, jqXHR) {
    // Network error — stop trying to load more
    window._threadsFullyLoaded = true;
  }).always(function() {
    window.pm_ajax_request_active = 0;
    window.load_more_threads_active = 0;
  });
  return false;
};
